import * as React from 'react';
import moment from 'moment';
import { CartItemsProps, CartItemGroupViewProps } from '../../components/cart/cart-items';
import CartItem from '../../components/cart/cart-item';
import CartMessages from '../../components/cart/cart-messages';
import { AlternateCartItemType } from '../../classes/package-listing';

const CartItemGroupView: React.StatelessComponent<CartItemGroupViewProps> = props => {
    const anyPerformances = props.cartItems.length > 0;
    const seatMapItem = props.cartItems.sort((a, b) => { return a.cartItemId - b.cartItemId })[0];
    return (
        anyPerformances &&
        <div className={`stack ace-subs-cart-listing ${!props.isUnseated ? " ace-subs-cart-listing-seated" : ""}`}>
            <ul className="ace-subs-cart-summary">
                {
                    props.cartItems.sort((a, b) => { return a.cartItemId - b.cartItemId }).map((item, index) =>
                        <>
                            <CartItem key={item.cartItemId}
                                cartItem={item}
                                hideSeatMap={true}
                                showSeatMapOnly={false}
                                showTitleAndRemoveButton={true}
                            />
                        </>
                    )
                }
            </ul>
            {
                props.groupName.length > 0 &&
                <>
                    <div className="stack-xs">
                        <p className="bold" data-demo-label="Performance Group Description">{props.groupName}</p>
                        <CartMessages performanceGroupId={props.groupId} />
                    </div>
                </>
            }
            {
                props.isUnseated &&
                <>
                    <ul className={`ace-subs-cart stack`}>
                        {
                            props.cartItems.sort((a, b) => { return a.cartItemId - b.cartItemId }).map((item) =>
                                <>
                                    {/* This cart item actually displays zone selectors */}
                                    <CartItem key={item.cartItemId}
                                        cartItem={item}
                                        hideSeatMap={true}
                                        showAlternateChoiceSection={true}
                                        showAlternateReservationCheckbox={props.isUnseated && !item.selectedAlternateItem?.cartItemId}
                                    />
                                </>
                            )
                        }
                    </ul>

                    {/* This cart item is just for rendering the seatmap */}
                    <CartItem key={seatMapItem.cartItemId}
                        cartItem={seatMapItem}
                        hideSeatMap={false}
                        showSeatMapOnly={true}
                    />
                </>
            }
        </div>
    )
}

const CartItemsView: React.StatelessComponent<CartItemsProps> = props => {
    return (
        <>
            {
                props.requiresPerformanceGroups ?
                    props.performanceGroups.map(pg => {
                        const groupPerfIds = pg.tessPerformances.map(p => p.performanceId);
                        const groupPerformances = props.cartItems.filter(p => groupPerfIds.indexOf(p.cartItemId) >= 0);
                        return <CartItemGroupView isFixedPackage={props.isFixedPackage} key={pg.id} text={props.text}
                            cartItems={groupPerformances}
                            performanceMin={pg.minimumPerformances}
                            groupName={pg.description} groupId={pg.id} isUnseated={props.isUnseated} />
                    })
                    :
                    <CartItemGroupView
                        isFixedPackage={props.isFixedPackage}
                        text={props.text}
                        performanceMin={props.packageMin}
                        groupId={null}
                        groupName=""
                        cartItems={props.cartItems}
                        isUnseated={props.isUnseated}
                        toggleAlternateRequestType={props.toggleAlternateRequestType}
                    />
            }
        </>
    );
}

export default CartItemsView;